/**
 * !!! WARNING !!!
 * This balloon implementation is deprecated,
 * please use Podio.Views.SimpleBalloon instead.
 */

define('lib/Podio.UI.SimpleBalloon',['require','underscore','jquery','lib/jquery/jquery.removeClassByPrefix','lib/Podio.Gravity','lib/backbone/Backbone.PodioView','lib/Podio.UI.Tooltips','jst!simple_balloon/_balloon'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.removeClassByPrefix');

  var PodioGravity = require('lib/Podio.Gravity');

  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var tooltips = require('lib/Podio.UI.Tooltips');

  var jstBalloon = require('jst!simple_balloon/_balloon');

  return ViewPodioBase.extend({
    podioEvents: {
      'click .close-option' : 'onCloseButtonClicked'
    },

    initialize:function ( options ) {

      this._super();

       _.bindAll(this, 'render', 'renderContent', 'onWindowResize', 'destroy');

      this.elm = $('<div />', { 'class' : 'simple-balloon'} );
      this.setElement(this.elm.get(0));

      this.eventBus = this.options.eventBus;

      this.balloonId = this.options.balloonId || _.uniqueId('simpleballoon');

      this.content = this.options.content;
      this.offsets = this.options.offsets;
      this.contentClass = this.options.contentClass;
      this.arrowPosition = this.options.arrowPosition || 'center';
      this.arrowOffset = this.options.arrowOffset || 0;
      this.closeOptionEnabled = this.options.closeOptionEnabled || false;

      this.elmAttachmentTarget = this.options.elmAttachmentTarget;
      this.elmContainer = $('#wrapper');
      this.elmWindow = $(window);

      this.eventBridge = this.options.eventBridge;

      this.gravityHelper = new PodioGravity({
        gravityPriorities: ['n', 'w', 'e', 's'],
        arrowSpacing: 10
      });

      if( options.gravity ) {
        this.gravity = options.gravity;
      } else {
        this.gravity = 'n';
      }

    },

    isVisible: function() {
      return this.elm.is(':visible');
    },

    destroy: function() {
      this.elmWindow.off( 'resize.{0}'.format(this.balloonId) , this.onWindowResize );
      this.remove();
    },

    fadeIn: function() {
      this.elm.fadeIn(100);
    },

    fadeOut: function(delay) {
      var self = this;

      _.delay(function() {
        self.elm.fadeOut(100);
      }, delay || 0);
    },

    show: function() {
      this.fadeIn();
    },

    hide: function() {
      this.fadeOut();
    },

    renderAutoGravity: function() {

      var gravity = this.gravityHelper.calculateBestGravity( this.elmAttachmentTarget, this.elm );
      gravity = gravity ? gravity : 'center';

      if (gravity === 'n' || gravity === 's') {
        this.arrowPosition = 'left';
      } else {
        this.arrowPosition = 'top';
        this.arrowOffset = 75;
      }

      var gravityPosition = this.gravityHelper.calculateElementPositionByGravity( gravity, this.elm, this.elmAttachmentTarget, this.arrowOffset );

      // Update positions
      this.elm.removeClassByPrefix( 'gravity' );
      this.elm.addClass(' gravity-' + gravity );

      // Arrow position
      this.elm.removeClassByPrefix( 'arrow-' );
      this.elm.addClass(' arrow-' + this.arrowPosition );

      this.elm.css( gravityPosition.position );

    },

    renderGravity: function() {

      // TODO: *All* simpleBalloons should probably be changed to using auto gravity.
      if (this.gravity === 'auto') {
        this.renderAutoGravity();
        return;
      }

      // Figure out position
      var elmHeight = this.elm.outerHeight(true);
      var elmWidth = this.elm.outerWidth(true);

      var arrowOffset = 0;
      var arrowSpacing = 15;

      var attachmentPos = this.elmAttachmentTarget.offset();
      var attachmentWidth = this.elmAttachmentTarget.outerWidth(true);
      var attachmentHeight = this.elmAttachmentTarget.outerHeight(true);

      // Arrow position
      if( !this.arrowOffset && this.arrowPosition == 'top' ) {
        this.arrowOffset = 75;
      }
      if( !this.arrowOffset && this.arrowPosition == 'left' ) {
        this.arrowOffset = (attachmentWidth/2)+15;
      }

      var basePosition = {
        top: attachmentPos.top,
        left:  attachmentPos.left,
        right: attachmentPos.left+attachmentWidth,
        bottom: attachmentPos.top+attachmentHeight
      };

      // Set gravity
      var position;

      switch ( this.gravity ) {
        case 'n':
          this.arrowOffset = (this.arrowOffset === 0) ?  Math.floor( elmWidth / 2 ) : this.arrowOffset;

          if (this.arrowPosition === 'right') {
            position = {
              top: basePosition.top + attachmentHeight + arrowSpacing,
              left: basePosition.right - elmWidth - Math.floor( attachmentWidth / 2 ) + this.arrowOffset
            };
          }
          else {
            position = {
              top: basePosition.top + attachmentHeight + arrowSpacing,
              left: basePosition.left + Math.floor( attachmentWidth / 2 ) - this.arrowOffset
            };
          }
          break;
        case 's':
          this.arrowOffset = (this.arrowOffset === 0) ?  Math.floor( elmWidth / 2 ) : this.arrowOffset;

          position = {
            top: basePosition.top - arrowSpacing - elmHeight,
            left: basePosition.left + Math.floor( attachmentWidth / 2 ) - this.arrowOffset
          };
          break;
        case 'e':
          this.arrowOffset = (this.arrowOffset === 0) ?  Math.floor( elmHeight / 2 ) : this.arrowOffset;

          position = {
            top: basePosition.top + Math.floor( attachmentHeight / 2) - this.arrowOffset,
            left: basePosition.left - elmWidth - arrowSpacing
          };

          break;
        case 'w':
          this.arrowOffset = (this.arrowOffset === 0) ?  Math.floor( elmHeight / 2 ) : this.arrowOffset;
          position = {
            top: basePosition.top + Math.floor( attachmentHeight / 2) - this.arrowOffset,
            left: attachmentPos.left + attachmentWidth + arrowSpacing
          };
          break;
      }

      // Offsets
      if( this.offsets && this.offsets.left ) {
        position.left = position.left + this.offsets.left;
      }

      if( this.offsets && this.offsets.top ) {
        position.left = position.top + this.offsets.top;
      }

      // Update positions
      this.elm.removeClassByPrefix( 'gravity' );
      this.elm.addClass(' gravity-' + this.gravity );

      // Arrow position
      this.elm.removeClassByPrefix( 'arrow-' );
      this.elm.addClass(' arrow-' + this.arrowPosition );

      this.elm.css( position );
    },

    onWindowResize: _.debounce(function() {
      this.renderGravity();
    }, 50),

    render:function (elmAttachmentTarget) {

      this.renderContent();

      if( this.elm.parents(this.elmContainer).length ) {
        // this.elm has already been appended to container, so no need to re-do this over again. Just update content.
        return false;
      }

      if( this.contentClass ) {
        // Remove existing balloons to avoid conflicts
        $( '.{0}'.format( this.contentClass ) ).remove();
        // Add class
        this.elm.addClass( this.contentClass );
      }

      this.elm.appendTo( this.elmContainer );

      // Event bindings
      this.podioDelegateEvents(); // Bind events now, since this.el is now appended to the DOM, and delegation would work.
      this.elmWindow.on('resize.{0}'.format(this.balloonId), this.onWindowResize );

      // Gravity
      this.renderGravity();
    },

    renderContent: function() {

      var html = this.getTemplate(jstBalloon, {
        content : this.content,
        closeOptionEnabled: this.closeOptionEnabled
      });

      this.elm.html( html );
    },

    setContent: function(elmHtml) {
      var html = this.getTemplate(jstBalloon, {
        content : $('<div />').addClass('content-holder')[0].outerHTML,
        closeOptionEnabled: this.closeOptionEnabled
      });

      this.elm.html( html );
      this.elm.find('.content-holder').replaceWith(elmHtml);
    },

    onCloseButtonClicked: function(elmTarget, e) {
      e.stopPropagation();
      tooltips.hideAll();

      this.trigger( 'simpleBalloon.{0}:balloonClosed'.format(this.balloonId) );
      this.fadeOut();

      _.delay( this.destroy, 200);
    }

  });

});

